/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CompanyLayoutForLettersQueryVariables = {|
  companyId: string,
  companyLayoutId: string,
|};
export type CompanyLayoutForLettersQueryResponse = {|
  +Me: ?{|
    +Company: ?{|
      +businessPost: ?{|
        +companyLayout: ?{|
          +id: string,
          +tableId: number,
          +name: string,
          +layout: string,
        |}
      |}
    |}
  |}
|};
export type CompanyLayoutForLettersQuery = {|
  variables: CompanyLayoutForLettersQueryVariables,
  response: CompanyLayoutForLettersQueryResponse,
|};
*/


/*
query CompanyLayoutForLettersQuery(
  $companyId: ID!
  $companyLayoutId: ID!
) {
  Me {
    Company(id: $companyId) {
      businessPost {
        companyLayout(id: $companyLayoutId) {
          id
          tableId
          name
          layout
        }
      }
      id
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companyId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companyLayoutId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "companyId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "BusinessPost",
  "kind": "LinkedField",
  "name": "businessPost",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "companyLayoutId"
        }
      ],
      "concreteType": "CompanyLayout",
      "kind": "LinkedField",
      "name": "companyLayout",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tableId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "layout",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompanyLayoutForLettersQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "Company",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompanyLayoutForLettersQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "Company",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9705112b4db1f92afb78d776a4a334b7",
    "id": null,
    "metadata": {},
    "name": "CompanyLayoutForLettersQuery",
    "operationKind": "query",
    "text": "query CompanyLayoutForLettersQuery(\n  $companyId: ID!\n  $companyLayoutId: ID!\n) {\n  Me {\n    Company(id: $companyId) {\n      businessPost {\n        companyLayout(id: $companyLayoutId) {\n          id\n          tableId\n          name\n          layout\n        }\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '536f88d72c56ffe93ddd420c8561e43b';

module.exports = node;
